import React, { useCallback, useEffect, useState } from 'react';
import MainLayout from '../../components/Layout/MainLayout';
import NewChatWizardTopMenu from '../startChatWizard/NewChatWizardTopMenu';
import chatApi from '../../api/chatApi';
import SlotContainer from '../../components/common/Slots/SlotContainer';
import TableSelectResearch from '../../components/PageBlocks/Research/Lab/LabDialog/TableSelectResearch';
import { getMedicineNameStage, getTestingstageTaskOnTask } from '../../api/chatApi/chatApi';
import Slot from '../../components/common/Slots/Slot';
import ButtonWithProgress from '../../components/common/ButtonWithProgress';
import { useHistory, useLocation } from 'react-router-dom';
import { RoutePath } from '../../types'
import useTooltipState from '../../hooks/useTooltipState';
import TooltipDialog from '../../components/common/TooltipDialog';
import ChatTooltip from '../../components/Tooltips/ChatTooltip';
import useHasDifferentiatedDiagnosis from '../../hooks/useHasDifferentiatedDiagnosis';
import { Tabs, Tab, Box, Paper } from '@material-ui/core';
import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  InputLabel,
  MenuItem,
  Select
} from '@material-ui/core';

interface Stage {
  routePath: string
  routhPathCode: string
  activeStage: number
  code: string
  legend_id?: number
  testingstage_id: number
}

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`date-tabpanel-${index}`}
      aria-labelledby={`date-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box style={{ paddingTop: 16 }}>
          {children}
        </Box>
      )}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `date-tab-${index}`,
    'aria-controls': `date-tabpanel-${index}`,
  };
}

interface GroupedByDateItem {
  date: string;
  displayDate: string;
  analyses: any[];
  specialists: any[];
  sortOrder: number;
}

export default function LastAnalysesPage() {
  const hasDifferentiatedDiagnosis = useHasDifferentiatedDiagnosis();
  const [analyses, setAnalyses] = useState<any[]>([]);
  const [specialist, setSpecialist] = useState<any[]>([]);
  const [stages, setStages] = useState<Stage[]>([]);
  const [spec, setSpec] = useState<any>([])
  const [taskId, setTaskId] = useState<number>(0)
  const location = useLocation();
  const history = useHistory();
  const [tabValue, setTabValue] = useState(0);
  const [groupedByDate, setGroupedByDate] = useState<GroupedByDateItem[]>([]);
  const [openDifDialog, setOpenDifDialog] = useState(false);

  const getSpec = async () => {
    try {
      const res = await chatApi.getAllSpecialists()
      setSpec(res.result);
    } catch (error) {
      console.log('Ошибка getAllSpecialists', error)
    }
  }

  const [currentStage, setCurrentStage] = useState<Stage | null>(null);

  async function fetchAllStages() {
    try {
      const result = await getTestingstageTaskOnTask();
      setStages(result.data.testingstage_task_on_task);
      const currentStage = result.data.testingstage_task_on_task.find((stage: Stage) => stage.routePath === '/last_spe');
      setCurrentStage(currentStage);
    } catch (error) {
      console.error('Ошибка при загрузке этапов:', error);
    }
  }

  useEffect(() => {
    fetchAllStages();
    getSpec();
  }, []);

  const [medicineNameStage, setMedicineNameStage] = useState<string>('')
  const [difDiagnosisOptions, setDifDiagnosisOptions] = useState<any[]>([])
  const [selectedDifDiagnosisId, setSelectedDifDiagnosisId] = useState<string>('')
  const [difDiagnosisTaskId, setDifDiagnosisTaskId] = useState<number | null>(null)
  const [difDiagnosisLoading, setDifDiagnosisLoading] = useState(false)
  const [difDiagnosisSaving, setDifDiagnosisSaving] = useState(false)
  const [selectedQuestionName, setSelectedQuestionName] = useState<string | null>(null)
  const [selectedQuestionResponseId, setSelectedQuestionResponseId] = useState<string | number | null>(null)

  const getNameStage = useCallback(async () => {
    if (!taskId || !currentStage) {
      return
    }
    
    try {
      const result = await getMedicineNameStage({ task_id: taskId })
      
      if (result?.data?.MedicineNameStage) {
        const matchingStage = result.data.MedicineNameStage.find((item: any) => 
          item.testingstage_id === currentStage.testingstage_id
        )
        const stageName = matchingStage?.name
        setMedicineNameStage(stageName || '')
      } else {
        setMedicineNameStage('')
      }
    } catch (error) {
      console.error('Error fetching stage name:', error)
      setMedicineNameStage('')
    }
  }, [taskId, currentStage]);

  useEffect(() => {
    getNameStage()
  }, [getNameStage])

  // Функция для получения даты на основе значения date
  const getDisplayDate = useCallback((dateValue: number | null): { displayDate: string; sortOrder: number } => {
    const today = new Date();
    
    if (dateValue === null) {
      return {
        displayDate: 'Более 30 дней назад',
        sortOrder: 999
      };
    }

    const targetDate = new Date(today);
    targetDate.setDate(today.getDate() - dateValue);
    
    // Форматирование даты
    const day = targetDate.getDate().toString().padStart(2, '0');
    const month = (targetDate.getMonth() + 1).toString().padStart(2, '0');
    const year = targetDate.getFullYear();
    
    return {
      displayDate: `${day}.${month}.${year}`,
      sortOrder: dateValue
    };
  }, []);

  // Функция для группировки данных по датам
  const groupItemsByDate = useCallback((analysesItems: any[], specialistItems: any[]) => {
    const groupedMap = new Map<string, GroupedByDateItem>();

    analysesItems.forEach((item: any) => {
      const dateValue = item.date;
      const { displayDate, sortOrder } = getDisplayDate(dateValue);
      
      if (!groupedMap.has(displayDate)) {
        groupedMap.set(displayDate, {
          date: displayDate,
          displayDate,
          analyses: [],
          specialists: [],
          sortOrder
        });
      }
      groupedMap.get(displayDate)!.analyses.push(item);
    });

    specialistItems.forEach((item: any) => {
      const dateValue = item.date;
      const { displayDate, sortOrder } = getDisplayDate(dateValue);
      
      if (!groupedMap.has(displayDate)) {
        groupedMap.set(displayDate, {
          date: displayDate,
          displayDate,
          analyses: [],
          specialists: [],
          sortOrder
        });
      }
      groupedMap.get(displayDate)!.specialists.push(item);
    });
    return Array.from(groupedMap.values()).sort((a, b) => a.sortOrder - b.sortOrder);
  }, [getDisplayDate]);

  const normalizeDifDiagnosisList = (res: any) => {
    const raw = res?.result
    if (Array.isArray(raw)) return raw
    if (Array.isArray(raw?.result)) return raw.result
    return []
  }

  const normalizeDifDiagnosisTaskList = (res: any) => {
    const raw = res?.result
    if (Array.isArray(raw)) return raw
    if (Array.isArray(raw?.result)) return raw.result
    return []
  }

  const extractTaskIdFromResult = (taskResult: any): number | null => {
    if (taskResult == null) return null
    if (typeof taskResult === 'number') return taskResult
    if (typeof taskResult === 'object') {
      const id =
        taskResult?.id ??
        taskResult?.taskDifferentiatedDiagnosisId ??
        taskResult?.task_differentiated_diagnosis_id
      return id == null ? null : Number(id)
    }
    return null
  }

  const extractSelectedDifDiagnosisIdFromResult = (taskResult: any, optionsList: any[]): string => {
    if (taskResult == null) return ''

    if (typeof taskResult === 'number') {
      const match = (optionsList || []).find((o) => String(o?.id) === String(taskResult))
      return match ? String(match.id) : ''
    }

    if (typeof taskResult === 'object') {
      const id =
        taskResult?.differentiatedDiagnosisId ??
        taskResult?.differentiatedDiagnosis?.id ??
        taskResult?.differentiatedDiagnosis?.differentiatedDiagnosisId

      if (id != null) return String(id)

      const diagnosisText =
        taskResult?.differentiatedDiagnosis?.differentiatedDiagnosis ??
        taskResult?.differentiatedDiagnosis?.name ??
        taskResult?.differentiatedDiagnosis

      if (diagnosisText) {
        const matchByText = (optionsList || []).find(
          (o) => String(o?.differentiatedDiagnosis) === String(diagnosisText)
        )
        return matchByText ? String(matchByText.id) : ''
      }
    }

    return ''
  }

  const fetchDifDiagnosisModalData = async () => {
    if (!currentStage?.testingstage_id) return
    if (!selectedQuestionName) return
    if (selectedQuestionResponseId == null) return

    setDifDiagnosisLoading(true)
    setDifDiagnosisTaskId(null)
    setSelectedDifDiagnosisId('')
    try {
      const [allRes, allTasksRes] = await Promise.all([
        chatApi.getDifDiagnosisAll(),
        chatApi.getDifDiagnosisCurrentTask()
      ])

      const list = normalizeDifDiagnosisList(allRes)
      setDifDiagnosisOptions(list)

      const allTasks = normalizeDifDiagnosisTaskList(allTasksRes)
      const currentTask = allTasks.find((t: any) => {
        const stageOk = String(t?.testingStageId) === String(currentStage.testingstage_id)
        if (!stageOk) return false

        const questionIdOk = String(t?.questionValId) === String(selectedQuestionResponseId)
        const questionValOk = String(t?.questionVal) === String(selectedQuestionName)

        return questionIdOk && questionValOk
      })

      const nextTaskId = extractTaskIdFromResult(currentTask)
      setDifDiagnosisTaskId(nextTaskId)

      const nextSelectedId = extractSelectedDifDiagnosisIdFromResult(currentTask, list)
      if (nextSelectedId) setSelectedDifDiagnosisId(nextSelectedId)
    } catch (e) {
      console.log(e)
    } finally {
      setDifDiagnosisLoading(false)
    }
  }

  useEffect(() => {
    if (!openDifDialog) return
    fetchDifDiagnosisModalData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [openDifDialog, currentStage?.testingstage_id, selectedQuestionName, selectedQuestionResponseId])

  const handleSaveDifDiagnosisTask = async () => {
    if (!currentStage?.testingstage_id) return
    if (!selectedQuestionName) return
    if (selectedQuestionResponseId == null) return

    const selected = difDiagnosisOptions.find((o) => String(o?.id) === String(selectedDifDiagnosisId))
    if (!selected || !selected?.id) return

    const payload = {
      answerVal: null,
      answerValId: null,
      differentiatedDiagnosis: {
        differentiatedDiagnosis: selected.differentiatedDiagnosis,
        id: selected.id
      },
      differentiatedDiagnosisId: selected.id,
      id: difDiagnosisTaskId ?? null,
      questionVal: selectedQuestionName,
      questionValId: selectedQuestionResponseId,
      testingStageId: currentStage.testingstage_id,
      userTaskProceedId: null
    }

    setDifDiagnosisSaving(true)
    try {
      if (difDiagnosisTaskId != null) {
        await chatApi.updateDifDiagnosisTask(payload)
      } else {
        await chatApi.createDifDiagnosisTask(payload)
      }
      await fetchDifDiagnosisModalData()
    } catch (e) {
      console.log(e)
    } finally {
      setOpenDifDialog(false)
      setDifDiagnosisSaving(false)
    }
  }

  const openDifDialogForAnalysis = (row: any) => {
    if (!hasDifferentiatedDiagnosis) return
    const name = row?.name || ''
    const responseId = row?.responseId
    if (!name || responseId == null) return
    setSelectedQuestionName(name)
    setSelectedQuestionResponseId(responseId)
    // Симптом вернуть
    setOpenDifDialog(true)
  }

  const openDifDialogForSpecialist = (specialistName: string, responseId: any) => {
    if (!hasDifferentiatedDiagnosis) return
    if (!specialistName || responseId == null) return
    setSelectedQuestionName(specialistName)
    setSelectedQuestionResponseId(responseId)
    // Симптом вернуть
    setOpenDifDialog(true)
  }

  async function getTaskProceedPastResearch() {
    try {
      const result = await chatApi.getTaskProceedPastResearch()
      setAnalyses(result.result)
    } catch (error) {
      console.log('Ошибка getTaskProceedPastResearch', error)
    }
  }

  async function getTaskProceedPastSpecialist() {
    try {
      const result = await chatApi.getTaskProceedPastSpecialist()
      setSpecialist(result.result)
    } catch (error) {
      console.log('Ошибка getTaskProceedPastSpecialist', error)
    }
  }

  useEffect(() => {
    getTaskProceedPastResearch()
    getTaskProceedPastSpecialist()
  }, [])

  useEffect(() => {
    const grouped = groupItemsByDate(analyses || [], specialist || []);
    setGroupedByDate(grouped);
  }, [analyses, specialist, groupItemsByDate])

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setTabValue(newValue);
  };

  // Функция для перехода на следующий этап
  async function goToTheNextStage() {
    const currentPath = location.pathname;
    const currentStageObj = stages.find(stage => stage.routePath === currentPath);
    if (!currentStageObj) return;

    setHistoryStage(currentStageObj.activeStage)
    const currentActiveStage = currentStageObj.activeStage;

    const nextStageObj = stages
      .filter(stage => stage.activeStage > currentActiveStage)
      .sort((a, b) => a.activeStage - b.activeStage)[0];

    if (nextStageObj && nextStageObj.legend_id) {
      history.push(RoutePath.legend);
    } else if (nextStageObj) {
      history.push(nextStageObj.routePath);
    }
  }

  async function setHistoryStage(testingStage) {
    try {
      await chatApi.setTestingStageHistory(testingStage)
    } catch (error) {
      console.log('Ошибка setHistoryStage', error)
    }
  }

  const [tooltipState, openTooltip] = useTooltipState()

  async function unfinishedTaskHandler() {
    try {
      const response = await chatApi.unfinishedTask()
      setTaskId(response.result.taskId)
    } catch (err) {
      console.log('при выполнении unfinishedTaskHandler', err);
    }
  }

  useEffect(() => {
    unfinishedTaskHandler()
  }, [])

  return (
    <MainLayout
      desktopHeader={<NewChatWizardTopMenu title={'Прошлые исследования и консультации специалистов'} />}
      title={medicineNameStage || 'Прошлые исследования и консультации специалистов'}
      onClickTooltip={openTooltip}
    >
      <TooltipDialog {...tooltipState}>
        {currentStage && <ChatTooltip task_id={taskId} testingStageId={currentStage.testingstage_id} />}
      </TooltipDialog>

      {groupedByDate.length > 0 && (
        <Paper style={{ marginBottom: 16 }}>
          <Tabs
            value={tabValue}
            onChange={handleTabChange}
            variant="scrollable"
            scrollButtons="auto"
            aria-label="date tabs"
          >
            {groupedByDate.map((group, index) => (
              <Tab 
                key={index} 
                label={group.displayDate} 
                {...a11yProps(index)} 
              />
            ))}
          </Tabs>
        </Paper>
      )}

      {groupedByDate.map((group, groupIndex) => (
        <TabPanel key={groupIndex} value={tabValue} index={groupIndex}>
          <SlotContainer>
            {/* Анализы */}
            {group.analyses && group.analyses.length > 0 ? (
              (() => {
                const groupedAnalyses = group.analyses.reduce<Record<string, any[]>>((acc, current) => {
                  const groupName = current.groupName || 'Без группы';
                  if (!acc[groupName]) {
                    acc[groupName] = [];
                  }
                  acc[groupName].push(current);
                  return acc;
                }, {});

                return Object.entries(groupedAnalyses).map(([groupName, analyses]: [string, any[]]) => {
                  const processedAnalyses = analyses.map((it: any) => {
                    let json: any | null = null;

                    if (it.response.value && it.response.value.indexOf('}') !== -1) {
                      const replacedText = it.response.value.replace(/\\\\n/g, '\\n').replace(/<\/?br>/g, '\\n').replace(/«/g, '"');
                      try {
                        json = JSON.parse(replacedText, (key, value) => {
                          if (typeof value === 'string') {
                            return value.trim();
                          }
                          return value;
                        });
                      } catch (error) {
                        console.error(`Ошибка при парсинге JSON: ${error.message}`);
                      }
                    }

                    if (json === null) {
                      return {
                        name: it.typeName || '',
                        value: it.response.value || '',
                        unit: '',
                        reference: '',
                        responseId: it?.response?.id,
                      };
                    }

                    return {
                      name: json.name || '',
                      value: json.value || '',
                      unit: json.unit || '',
                      reference: json.reference || '',
                      responseId: it?.response?.id,
                    };
                  });

                  return (
                    <Slot key={groupName} title={groupName} color='primary'>
                      <TableSelectResearch
                        rows={processedAnalyses}
                        onRowClick={hasDifferentiatedDiagnosis ? openDifDialogForAnalysis : undefined}
                      />
                    </Slot>
                  );
                });
              })()
            ) : null}
            
            {/* Специалисты */}
            {group.specialists && group.specialists.length > 0 && (
              <Slot title='Прошлые специалисты' color='primary'>
                {group.specialists.map((el, itemIndex) => {
                  const specialistName = spec && spec.length > 0
                    ? spec.find(specName => specName.id === el.anamnesisId)?.name
                    : '';

                  const responseId = el?.response?.id ?? el?.id ?? null;

                  return (
                    <div
                      key={itemIndex}
                      style={{ padding: '10px 31px', cursor: hasDifferentiatedDiagnosis ? 'pointer' : undefined }}
                      onClick={hasDifferentiatedDiagnosis ? () => openDifDialogForSpecialist(specialistName, responseId) : undefined}
                    >
                      <div style={{ fontSize: '0.875rem', fontWeight: 600, fontFamily: 'inherit' }}>
                        {specialistName}
                        <div style={{ fontSize: '0.875rem', fontWeight: 400, fontFamily: 'inherit' }}>
                          {el.value ? String(el.value).split(/\\n|\r?\n/).map((line, lineIndex) => (
                            <React.Fragment key={lineIndex}>
                              {line}
                              <br />
                            </React.Fragment>
                          )) : 'Нет описания'}
                        </div>
                      </div>
                    </div>
                  );
                })}
              </Slot>
            )}

            {/* Если нет ни анализов, ни специалистов для этой даты */}
            {(!group.analyses || group.analyses.length === 0) && 
             (!group.specialists || group.specialists.length === 0) && (
              <div>Данные за этот период не найдены</div>
            )}
          </SlotContainer>
        </TabPanel>
      ))}

      {groupedByDate.length === 0 && (
        <SlotContainer>
          <div>Прошлых анализов и специалистов не найдено</div>
        </SlotContainer>
      )}

      <Dialog
        open={openDifDialog}
        onClose={() => setOpenDifDialog(false)}
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle>Симптом</DialogTitle>
        <DialogContent dividers>
          <div style={{ display: 'flex', gap: 12, alignItems: 'flex-end', flexWrap: 'wrap' }}>
            <FormControl variant="outlined" size="small" style={{ minWidth: 320, flex: '1 1 320px' }}>
              <InputLabel id="dif-diagnosis-select-label">Симптом</InputLabel>
              <Select
                labelId="dif-diagnosis-select-label"
                value={selectedDifDiagnosisId}
                onChange={(e) => setSelectedDifDiagnosisId(String(e.target.value))}
                label="Симптом"
                disabled={difDiagnosisLoading || difDiagnosisSaving}
                MenuProps={{
                  disablePortal: true
                }}
              >
                <MenuItem value="">
                  <em>Выберите Симптом</em>
                </MenuItem>
                {difDiagnosisOptions.map((opt: any) => (
                  <MenuItem key={opt.id} value={String(opt.id)}>
                    {opt.differentiatedDiagnosis || `Диагноз ${opt.id}`}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </div>
        </DialogContent>
        <DialogActions style={{ padding: '12px 24px' }}>
          <Button
            onClick={() => setOpenDifDialog(false)}
            disabled={difDiagnosisLoading || difDiagnosisSaving}
          >
            Закрыть
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={handleSaveDifDiagnosisTask}
            disabled={difDiagnosisLoading || difDiagnosisSaving || !selectedDifDiagnosisId}
            style={{ minWidth: 160 }}
          >
            {difDiagnosisSaving ? (
              <span style={{ display: 'inline-flex', alignItems: 'center', gap: 8 }}>
                <CircularProgress size={18} color="inherit" />
                {difDiagnosisTaskId != null ? 'Обновление' : 'Сохранение'}
              </span>
            ) : (
              (difDiagnosisTaskId != null ? 'Обновить' : 'Сохранить')
            )}
          </Button>
        </DialogActions>
      </Dialog>

      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          margin: '0px 0px 20px 0px',
          paddingBottom: "30px"
        }}
      >
        <ButtonWithProgress
          variant='contained'
          color='primary'
          onClick={() => (goToTheNextStage())}
        >
          Следующий этап
        </ButtonWithProgress>
      </div>
    </MainLayout>
  )
}